import React, { useEffect } from 'react';
import { navigate } from 'gatsby';

const IndexPage = () => {
  useEffect(() => {
    navigate('/home/', { replace: true });
  }, []);

  return <></>;
};

export default IndexPage;
